import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  createSpecification,
  getAllSpecifications,
  updateOnboarding,
  updateSpecification,
} from '../../api/specification'
import { OnboardingStatus, Specification } from '../../types/specification'
import { handleError } from '../../utils/errorHandler'

export const createSpecificationAction = createAsyncThunk<
  Specification,
  Specification,
  { rejectValue: string }
>('specification/create', async (specification, thunkAPI) => {
  try {
    const response = await createSpecification(specification)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const fetchSpecificationsAction = createAsyncThunk<
  Specification[],
  void,
  { rejectValue: string }
>('specification/fetchAll', async (_, thunkAPI) => {
  try {
    const response = await getAllSpecifications()
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const updateSpecificationAction = createAsyncThunk<
  Specification,
  { id: string; settings: Specification },
  { rejectValue: string }
>('settings/update', async ({ id, settings }, thunkAPI) => {
  try {
    const response = await updateSpecification(id, settings)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updateOnboardingAction = createAsyncThunk<
  Specification,
  {
    id: string
    status: OnboardingStatus
    stepIndex?: number
    version?: string
  },
  { rejectValue: string }
>('settings/updateOnboarding', async ({ id, ...payload }, thunkAPI) => {
  try {
    const response = await updateOnboarding(id, payload)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
